import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import apiCustom from "../../utils/ApiCustom";

import imageBCCU from "../../assets/Hoi-thanh-vien-bccu.png";
import imageSD from "../../assets/so-do.jpg";
import { Link } from "react-router-dom";
import { HomeIcon } from "@heroicons/react/24/outline";
function About() {
  const slug = useLocation();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const posts = useSelector((state) => state.posts.posts);

  useEffect(() => {
    const post = posts
      ?.find((post) => post.slug === slug?.pathname?.substring(1));
    window.scrollTo(0, 0);
    const fetchArticle = async () => {
      try {
        if (!post) {
          setError("Post not found");
          setLoading(false);
          return;
        }
        const response = await apiCustom.get(`posts-public/${post.id}`);
        setArticle(response.data.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchArticle();
  }, [slug, posts]);

  if (loading) {
    return <div className="container mx-auto px-4">Loading...</div>;
  }

  if (error) {
    return <div className="container mx-auto px-4">Error: {error}</div>;
  }
  return (
    <div className="container mx-auto">
      <nav className="flex text-gray-500 text-sm mb-4" aria-label="Breadcrumb">
        <ol className="inline-flex items-center space-x-1 md:space-x-2 flex-wrap">
          <li className="inline-flex items-center">
            <Link to="/" className="inline-flex items-center hover:text-blue-600 font-medium">
              <HomeIcon className="w-4 h-4 mr-2 text-gray-400" />
              Trang chủ
            </Link>
          </li>
          <li>
            <div className="flex items-center">
              <svg className="w-3 h-3 mx-2 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M7.05 4.05a.75.75 0 011.06 0l5.25 5.25a.75.75 0 010 1.06l-5.25 5.25a.75.75 0 11-1.06-1.06L11.19 10 7.05 5.91a.75.75 0 010-1.06z" />
              </svg>
              <span className="ml-1 text-gray-400 font-medium">Giới thiệu</span>
            </div>
          </li>
        </ol>
      </nav>
      <div className="p-6 bg-base-100 shadow-lg rounded-lg">
        <h1 className="text-3xl font-bold">{article.title}</h1>
        <div className="flow-root">
          <div className="sun-editor-editable">
            <div
              className="prose max-w-none"
              dangerouslySetInnerHTML={{ __html: article?.content }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
